import { h, resolveComponent } from 'vue';
import EmptyDivWithSlot from '../components/utility/EmptyDivWithSlot.vue';
import TabsView from '../views/TabsView/index.vue';
import TabsViewBeforeEnterGuard from './guards/beforeEnter/tabsView';
import TransitionViewBeforeEnterGuard from './guards/beforeEnter/transitionView';

export default [{
  path: '/:locale/:path/',
  component: {
    render() { return h(resolveComponent('router-view')); },
  },
  children: [
    {
      path: '',
      name: 'landing',
      component: () => import('../views/LandingView/index.vue'),
      meta: {
        scrollTo: 'top',
      },
    },
    {
      path: 'issue',
      component: () => import('../views/IssuesView/index.vue'),
      props: true,
      children: [{
        path: '',
        name: 'issuesView',
        components: {
          searchable: EmptyDivWithSlot,
        },
        meta: { scrollTo: '.searchFilters.form' },
      }, {
        path: 'tabs/:tabId',
        name: 'tabsView',
        beforeEnter: TabsViewBeforeEnterGuard,
        components: {
          tabs: TabsView,
        },
      }],
    },
    {
      path: 'faq/:faqId',
      name: 'faqView',
      component: () => import('../views/FaqView/index.vue'),
      meta: {
        scrollTo: 'top',
      },
    },
    {
      path: 'ql/:transitionName',
      name: 'transitionView',
      beforeEnter: TransitionViewBeforeEnterGuard,
      component: () => import('../views/TransitionView/index.vue'),
      meta: {
        scrollTo: 'top',
      },
    },
    {
      path: '/:locale/:path/:pathMatch(.*)*',
      redirect: (to) => ({ path: `/${to.params.locale}/${to.params.path}` }),
      component: () => import('../views/LandingView/index.vue'),
    },
  ],
}];
